module.exports = __webpack_public_path__ + "static/media/check-round-light.14ccc801.svg";